<template>
  <b-row>
    <b-col cols="12">
      <users-table />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import UsersTable from './UsersTable.vue'

export default {
  components: {
    BRow,
    BCol,

    UsersTable,

  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
